import React, { RefObject, useEffect, useMemo, useRef } from 'react';

export const useProjectsTreePopover = (rowsMap: Map<string, RefObject<HTMLDivElement>[]>) => {
    const popoverRef = useRef<any>(null);

    useEffect(() => {
        const classesAllowedForPopover = [
            '.ant-popover-inner',
            '.ant-splitter-bar-dragger',
            '.project-item',
            '.project-item-size-dragger',
        ];

        let hideTimeout = 0 as unknown as ReturnType<typeof setTimeout>;

        const handleMouseMove = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            if (target) {
                let allowedClass = false;

                for (const classToCheck of classesAllowedForPopover) {
                    allowedClass ||= Boolean(target.closest(classToCheck));
                }

                if (!allowedClass) {
                    if (hideTimeout === (0 as any)) {
                        hideTimeout = setTimeout(() => {
                            popoverRef.current?.hide();
                        }, 100);
                    }
                } else {
                    clearTimeout(hideTimeout);
                    (hideTimeout as any) = 0;
                }
            }
        };

        document.addEventListener('mousemove', handleMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return useMemo(() => {
        const onMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
            const itemId = e.currentTarget?.getAttribute('data-item-id') ?? '';
            const row = rowsMap.get(itemId);
            if (row) {
                const lastCell = row[row.length - 1];
                if (lastCell) {
                    popoverRef.current?.show(itemId, lastCell.current);
                }
            }
        };

        const onMouseLeave = () => {};

        return {
            popoverRef,
            onMouseEnter,
            onMouseLeave,
        };
    }, [popoverRef]);
};
